// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__35wN0","icon":"Card_icon__146nY","title":"Card_title__Ip0in"};